module.exports = function() {
  return new Worker(__webpack_public_path__ + "d51b7d734594c2fa0d43.worker.js");
};